import Cookies from 'js-cookie';
import { REGION_COOKIE_NAME, REGION_CONFIRMED_COOKIE_NAME } from '../constants';

export class UserGeoService {
    static checkRegionConfirmed() {
        return Boolean(Cookies.get(REGION_CONFIRMED_COOKIE_NAME));
    }

    static confirmRegion() {
        Cookies.set(REGION_CONFIRMED_COOKIE_NAME, '1', { expires: 30 });
    }

    static getSettledRegion() {
        return Cookies.get(REGION_COOKIE_NAME).replaceAll('+', ' ') || null;
    }

    static setRegion(regionName) {
        this.confirmRegion();
        Cookies.set(REGION_COOKIE_NAME, regionName);
        window.location.reload();
    }
}
